export enum UserRoles {
    blocked = -1,
    neutral = 0,
    reader = 1,
    editor = 2,
    admin = 3,
}
